<template lang="html">
  <div :class="setClassBG()">
    <div v-if="isLoading" class="loadingLayout text-xs-center">
      <v-progress-circular :size="70" :width="5" indeterminate color="black"></v-progress-circular>
    </div>
    <v-container class="centerDiv" v-else>
      <section>
        <v-layout column align-center justify-center class="white--text border">
          <v-flex xs12 md12 class="hidden-sm-and-down">
            <h1 class="white--text mb-2 text-xs-center">วาระที่ {{agendaInfo.agenda}} {{agendaInfo.agenda_title}}</h1>
            <h2 class="white--text mb-2 text-xs-center">{{ memberInfo.firstname }} {{ memberInfo.lastname }}</h2>
            <div class="subheading mb-3 text-xs-center">จำนวนหุ้น {{ setQShare(memberInfo.q_share) }} หุ้น</div>
          </v-flex>
          <v-flex xs12 md12 class="hidden-md-and-up">
            <h4 class="white--text mb-2 text-xs-center">วาระที่ {{agendaInfo.agenda}}</h4>
            <h5 class="white--text mb-2 text-xs-center">{{agendaInfo.agenda_title}}</h5>
            <h5 class="white--text mb-2 text-xs-center">{{ memberInfo.firstname }} {{ memberInfo.lastname }}</h5>
            <h5 class="mb-3 text-xs-center">จำนวนหุ้น {{ setQShare(memberInfo.q_share) }} หุ้น</h5>
          </v-flex>
          <v-flex xs12>
            <h1 class="mt-3 mb-3">ลงคะแนน : {{vote}}</h1>
          </v-flex>
          <v-flex xs6>
            <v-btn class="success darken-4 mr-1 mt-3" dark @click.native="cancel">กลับไปหน้าแรก</v-btn>
            <v-btn class="primary darken-4 mt-3" dark @click.native="editData">แก้ไข</v-btn>
          </v-flex>
        </v-layout>
      </section>
    </v-container>
  </div>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      isLoading: false,
      memberInfo: {
        firstname: '',
        lastname: '',
        q_share: ''
      },
      vote: '',
      agendaInfo: {
        agenda_id: '',
        agenda: '',
        agenda_title: '',
        calculatetype: ''
      },
      member_id: '',
      agenda_id: ''
    }
  },
  created () {
    this.isLoading = true
    this.checkVote()
  },
  computed: {
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    },
    qrcodeId () {
      return this.$route.params.id.slice(1, this.$route.params.id.length)
    },
    scanType () {
      return this.$route.params.id.slice(0, 1)
    }
  },
  methods: {
    setClassBG () {
      return [{'bg': !this.isLoading}]
    },
    checkVote () {
      if (this.qrcodeId) {
        var id = this.qrcodeId
        this.member_id = id.slice(0, id.length - 4)
        this.agenda_id = id.slice(-4)
      } else {
        if (this.scanType === 'w') {
          this.$router.push('/qrscanerweb')
        } else {
          this.$router.push('/qrscaner')
        }
        return
      }
      var source = { term: this.termYear.term, year: this.termYear.year, memberid: this.member_id, agenda_id: parseInt(this.agenda_id) }
      this.axios.post(process.env.API + '/checkVote', source).then((response) => {
        this.isLoading = false
        var result = response.data
        if (result.status === 'success') {
          this.vote = result.info.memberInfo.vote
          this.agendaInfo.agenda_title = result.info.agendaInfo.short_title
          this.agendaInfo.agenda = result.info.agendaInfo.agenda
          this.agendaInfo.agenda_id = result.info.agendaInfo.agenda_id
          this.memberInfo.memberid = result.info.memberInfo.memberid
          this.memberInfo.firstname = result.info.memberInfo.firstname
          this.memberInfo.lastname = result.info.memberInfo.lastname
          this.memberInfo.q_share = result.info.memberInfo.q_share
        } else if (result.status === 'fail' && result.message === 'Not found memberid') {
          this.$swal('ไม่พบข้อมูลผู้ถือหุ้น', '', 'error')
          if (this.scanType === 'w') {
            this.$router.push('/qrscanerweb')
          } else {
            this.$router.push('/qrscaner')
          }
        } else if (result.status === 'fail' && result.message === 'Not found agenda_id') {
          this.$swal('ไม่พบข้อมูลวาระการประชุม', '', 'error')
          if (this.scanType === 'w') {
            this.$router.push('/qrscanerweb')
          } else {
            this.$router.push('/qrscaner')
          }
        } else {
          this.$swal('ไม่พบข้อมูล', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
          if (this.scanType === 'w') {
            this.$router.push('/qrscanerweb')
          } else {
            this.$router.push('/qrscaner')
          }
        }
      })
    },
    editData () {
      this.$router.push('/vote/' + this.scanType + this.qrcodeId)
    },
    cancel () {
      if (this.scanType === 'w') {
        this.$router.push('/qrscanerweb')
      } else {
        this.$router.push('/qrscaner')
      }
    },
    setQShare (number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 })
    }
  }
}
</script>

<style lang="css" scoped>
.border{
  border-radius: 3em;
  border-spacing: 50px 70px;
  padding: 3em;
  opacity: 0.95;
  background: #000000;
}
.centerDiv{
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%)
}
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.bg {
  background-image: url('/static/img/icons/104.jpg');
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media only screen and (max-width: 600px) {
  .border{
    padding: 2em 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Submitqrcode.vue